import { render, staticRenderFns } from "./btnBackTop.vue?vue&type=template&id=13aedc8e&scoped=true&"
import script from "./btnBackTop.vue?vue&type=script&lang=js&"
export * from "./btnBackTop.vue?vue&type=script&lang=js&"
import style0 from "./btnBackTop.vue?vue&type=style&index=0&id=13aedc8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aedc8e",
  null
  
)

/* custom blocks */
import block0 from "./btnBackTop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports